export class EmailLog {
  ID?: number; // Primary Key, optional because it's likely auto-generated
  pet_no?: number | null;
  client_no?: number | null;
  clinic_no?: number | null;
  username?: string | null;

  EmailTo: string;
  EmailFrom: string;
  EmailSubject: string;
  EmailBody: string;
  EmailDate?: Date | string; // use Date for client side, or string for plain JSON

  ApiStatus: boolean; // true (succeeded), false (failed)
  ApiRequestId?: string | null;
  ApiEmailId?: string | null;
  ApiRemarks?: string | null;

  constructor(
    ID: number,
    pet_no: number | null,
    client_no: number | null,
    clinic_no: number | null,
    username: string | null,
    EmailTo: string,
    EmailFrom: string,
    EmailSubject: string,
    EmailBody: string,
    EmailDate: Date | string,
    ApiStatus: boolean,
    ApiRequestId: string | null,
    ApiEmailId: string | null,
    ApiRemarks: string | null
) {
    this.ID = ID;
    this.pet_no = pet_no;
    this.client_no = client_no;
    this.clinic_no = clinic_no;
    this.username = username;
    this.EmailTo = EmailTo;
    this.EmailFrom = EmailFrom;
    this.EmailSubject = EmailSubject;
    this.EmailBody = EmailBody;
    this.EmailDate = EmailDate;
    this.ApiStatus = ApiStatus;
    this.ApiRequestId = ApiRequestId;
    this.ApiEmailId = ApiEmailId;
    this.ApiRemarks = ApiRemarks;
  }
}